import { useCallback, useEffect, useState } from 'react'

/**
 * Ephemeral expand/collapse state for email attachment trees.
 * Resets when `resetKey` changes (folder, search query, or sort).
 */
export function useEmailAttachmentExpansion(resetKey: string) {
  const [expandedIds, setExpandedIds] = useState<Set<string>>(() => new Set())

  useEffect(() => {
    setExpandedIds(new Set())
  }, [resetKey])

  const isExpanded = useCallback((fileId: string) => expandedIds.has(fileId), [expandedIds])

  const toggleExpanded = useCallback((fileId: string) => {
    setExpandedIds((current) => {
      const next = new Set(current)
      if (next.has(fileId)) next.delete(fileId)
      else next.add(fileId)
      return next
    })
  }, [])

  return { expandedIds: expandedIds as ReadonlySet<string>, isExpanded, toggleExpanded }
}
